import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import CountWidget from './count-widget.component';
import {getCounters} from '../../services/reports.service';
import {
  CONTENT_ALIAS,
  DEFAULT_CHANNEL,
  SHOW_CONTENT_CHANNELS,
  SHOW_CONTENT_CATEGORIES,
  SHOW_CONTENT_VIDEOS,
  SHOW_CONTENT_SERIES,
  SHOW_CONTENT_SHOWS,
  LS_ADMIN_USER_ID,
} from '../../config/const.config';
import ROUTE_PATH from '../../config/routes.config';
import { getLocalValue,checkAdminUserRole } from '../../utils/local-cache.util';

const Counters = () => {
  const [counters, setCounters] = useState({
    channels: 0,
    videos: 0,
    categories: 0,
    series: 0,
    shows: 0,
  });

  useEffect(() => {
    const adminUserId = getLocalValue(LS_ADMIN_USER_ID);
    const adminUserRole = checkAdminUserRole();
    const params = {
      adminUserId,
      adminUserRole
    }
    getCounters(params)
      .then((res) => {
        setCounters({
          ...counters,
          channels: res?.data?.channels || 0,
          categories: res?.data?.categories || 0,
          series: res?.data?.series || 0,
          shows: res?.data?.shows || 0,
          videos: res?.data?.videos || 0,
        });
      })
      .catch(() => {
        // ignore
      });
  }, []);

  return (
    <Grid container spacing={3} mb={3}>

      {SHOW_CONTENT_CHANNELS && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.CHANNEL_PLURAL}`}
            total={counters.channels}
            color="info"
            icon="ic:twotone-checklist"
            navLink={ROUTE_PATH.CONTENT_CHANNELS}
          />
        </Grid>
      )}
      {SHOW_CONTENT_CATEGORIES && (
        <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.CATEGORY_PLURAL}`}
            total={counters.categories}
            color="warning"
            icon="iconamoon:category"
            navLink={ROUTE_PATH.CONTENT_CATEGORIES}
          />
        </Grid>
      )}

      {SHOW_CONTENT_SERIES && (
          <Grid
            item
            xs={12}
            sm={!DEFAULT_CHANNEL ? 3 : 4}
            md={!DEFAULT_CHANNEL ? 3 : 4}
          >
            <CountWidget
              title={`${CONTENT_ALIAS.SERIES_PLURAL}`}
              total={counters.series}
              color="success"
              icon="bi:collection-play"
              navLink={ROUTE_PATH.CONTENT_SERIES}
            />
          </Grid>
      )}      
      {SHOW_CONTENT_SHOWS && (
          <Grid
            item
            xs={12}
            sm={!DEFAULT_CHANNEL ? 3 : 4}
            md={!DEFAULT_CHANNEL ? 3 : 4}
          >
            <CountWidget
              title={`${CONTENT_ALIAS.SHOW_PLURAL}`}
              total={counters.shows}
              color="error"
              icon="stash:podcast-duotone"
              navLink={ROUTE_PATH.CONTENT_SHOWS}
            />
          </Grid>
      )}      
      {SHOW_CONTENT_VIDEOS && (
          <Grid
          item
          xs={12}
          sm={!DEFAULT_CHANNEL ? 3 : 4}
          md={!DEFAULT_CHANNEL ? 3 : 4}
        >
          <CountWidget
            title={`${CONTENT_ALIAS.VIDEO_PLURAL}/ ${CONTENT_ALIAS.AUDIO_PLURAL}`}
            total={counters.videos}
            color="primary"
            icon="octicon:video-16"
            navLink={ROUTE_PATH.CONTENT_VIDEOS}
          />
        </Grid> 
      )}     
    </Grid>
  );
};

export default Counters;
